import { Box, Drawer } from "@mui/material";
import { create } from "zustand";
import Spinner from "../components/Spinner";
import { isValidElement, useRef } from "react";

export const useAppDrawer = create((set, get) => ({
  open: false,
  content: '',
  locked: false,
  args: {
    close: () => {}
  },
  setOpen: open => set({ open }),
  closeDrawer: (unlock = null) => set({ open: false, locked: unlock ? false : get().locked }),
  setContent: content => set({ content }),
  lockDrawer: locked => set({ locked }),
  /**
   * Funzione mutevole: se `content` non è un componente, allora ritorna una promise, 
   * così da gestire eventi in modo asincrono in base alle operazioni eseguite nel drawer.
   * Altrimenti è solo un drawer.
   * @param {mixed} content react component or function
   * @param {object} inArgs drawer arguments
   * @returns {Promise|null}
   */
  invokeDrawer: async (content, inArgs) => {
    if (!isValidElement(content) && typeof content === "function") {
      return new Promise((resolve, reject) => {
        set({ 
          content: content({resolve, reject, close: get().closeDrawer} ), 
          args: {
            ...inArgs,
            close: () => {
              reject();
              if(inArgs.close) {
                inArgs.close();
              }
            },
          },
          open: true
        });
      });
    } else {
      set({ content, open: true });
    }
  }
}));

export const AppDrawer = () => {
  const {content, locked, open, args, setOpen} = useAppDrawer();
  const contentRef = useRef();
  
  const onClose = () => {
    if(!locked) {
      setOpen(false);
      args.close();
    }
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '90%',
          maxWidth: '460px',
          display: 'flex',
          flexDirection: 'column',
        }
      }}
      sx={{
        flexShrink: 0,
      }}
    >
      <Box ref={contentRef} sx={{
        pointerEvent: locked ? 'none' : 'initial',
        position: 'relative',
        height: '100%',
        // overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}>
        {locked && (
          <Spinner sx={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, }} />
        )}
        {content}
      </Box>
    </Drawer>
  )
}